import { action, computed, observable } from 'mobx';

import { ChoiceStore } from 'ui/base/input';
import { BusyStore } from 'ui/base/button';

import { Optional, ResultKind } from 'services/base/types';
import { IAccountsDomain } from 'services/accounts/types';
import { UpdatePangolinResult, update } from 'services/accounts/pangolin_service';

import { DeploymentProfile, deploymentProfileSettings, DeploymentSettings } from 'assets/enums/deployment_profiles/deployment_profiles';

export class AddPangolinProfileStore {
  readonly profileChoices: ChoiceStore<DeploymentProfile>;

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.profileChoices = new ChoiceStore<DeploymentProfile>({
      [DeploymentProfile.PASSIVE]: DeploymentProfile.PASSIVE,
      [DeploymentProfile.ACTIVE_FULL]: DeploymentProfile.ACTIVE_FULL,
      [DeploymentProfile.ACTIVE_INTERNET]: DeploymentProfile.ACTIVE_INTERNET,
    }, DeploymentProfile.PASSIVE);

    this.busy = new BusyStore();
  }

  @action.bound
  async handleSubmit(domain: IAccountsDomain, id: string): Promise<UpdatePangolinResult> {
    const profileSettings = this.profileSettings;
    if (profileSettings !== undefined) {
      return await update({
        domain, id,
        redirectModeBridgeEnabled: profileSettings.enablePhysicalIntercept,
        redirectModeUnicastEnabled: profileSettings.enableUnicastSpoofing,
        redirectModeUnicastTypeRequest: profileSettings.useUnicastRequest,
        redirectModeUnicastTypeResponse: profileSettings.useUnicastResponse,
        redirectModeUnicastNetworkInternet: profileSettings.redirectInternetWithUnicast,
        redirectModeUnicastNetworkInternal: profileSettings.redirectInternalWithUnicast,
        redirectModeBroadcastEnabled: profileSettings.enableBroadcastSpoofing,
        redirectModeBroadcastTypeRequest: profileSettings.useBroadcastRequest,
        redirectModeBroadcastTypeResponse: profileSettings.useBroadcastResponse,
        redirectModeBroadcastHostGateways: profileSettings.spoofGatewayWithBroadcast,
        redirectModeBroadcastHostHosts: profileSettings.spoofHostsWithBroadcast,
        masqueradeEgress: profileSettings.masqueradeEgress,
      });
    }

    return { kind: ResultKind.SYSTEM_ERROR };
  }

  @computed
  get profileSettings(): Optional<DeploymentSettings> {
    if (this.profileChoices.value === undefined) return undefined;
    return deploymentProfileSettings[this.profileChoices.value];
  }
}
